import styled from "styled-components"

export const ModalWrapper = styled.div`

.amep {
    &_overlay {
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(1, 1, 1, 35%);
        z-index: 10;
        transition: all 0.3s linear;
    }
    &_container {
        position: fixed;
        top: 42px;
        width: 80vw;
        left: calc((100vw - 80vw) / 2);
        padding: 12px;
        border-radius: 4px;
        min-height: 200px;
        background-color: #fff;
        z-index: 20;
        transition: all 0.3s linear;
    }
    &_header {
        font-size: 1.4rem;
        text-align: center;
        border-bottom: 1px solid #e2c1c1;
        padding-bottom: 12px;
    }
    &_body {
        margin: 0;
        padding: 0;
        list-style: none;
        max-height: 70vh;
        overflow-y: scroll;
    }
    &_item {
        &_image {
            display: flex;
            align-items: center;
            div {
                width: 150px;
                height: 150px;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                   width: 100%;
                   object-fit: cover;
                }
            }
            input {
                height: 35px;
                border: 1px solid #e2c1c1;
                border-radius: 4px;
                outline: none;
                &:focus {
                    border: 1px solid #1c1c1c;
                }
                margin-right: 4px;
            }
          
        }
        &_input {
         
            select {
                width: 100%;
                height: 40px;
                border-radius: 4px;
                outline: none;
                background-color: #fff;
                &:focus {
                    border: 1px solid #1c1c1c;
                }
            }
            textarea {
                padding: 0 12px;
                max-width: 100%;
                min-width: 100%;
                min-height: 100px;
                max-height: 100px;
                border-radius: 4px;
                outline: none;
                color: #1c1c1c;
                &:focus {
                    border: 1px solid #1c1c1c;
                }
            }
            
        }
     
    }
    &_footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 22px;
        padding-top: 12px;
        border-top: 1px solid #e2c1c1;
        button {
            margin-left: 12px;
            width: 120px;
            border: none;
            outline: none;
            color: #fff;
            height: 35px;
            i {
                margin-right: 4px;
            }
          
        }
    }
}

div.DraftEditor-root {
    height: 360px;
    width: auto;
    overflow-y: auto;
}

div.DraftEditor-editorContainer,
div.public-DraftEditor-content {
    height: 100%;
}

`
